import { ApiClientError } from './ApiClientError';

/**
 * 権限エラー
 */
export class ForbiddenError extends ApiClientError {
  override name = 'ForbiddenError';
}
